import { ApiClient, Helper } from "zoox-infra";

export default class CountryService {
  constructor() {
    this.apiClient = new ApiClient();
  }

  getAll(name) {
    let url = "open/country/list";
    if (name) {
      url = Helper.updateQueryString("name", name, url);
    }
    return this.apiClient.get(url, true, false);
  }

  getCityById(id) {
    return this.apiClient.get(`open/city/${id}`, true, false);
  }
}
